import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { EllipsisTableCell } from 'components/common/CommonStyles';
import OfferPaymentPlanParamsRowComponent from './OfferPaymentPlanParamsRowComponent';

function OfferPaymentPlanParamsListView({
  fixedTableColumns,
  scheduleCellParamColumns,
  scheduleCellParamValues,
  handleRowPropertyChange,
  handlePropertyParamChange,
  getDynamicInputParams,
  isEditable
}) {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {fixedTableColumns &&
              fixedTableColumns.map(n => {
                return (
                  <Tooltip title={n.cellParamName} key={n.cellParamId}>
                    <EllipsisTableCell>
                      <strong>{n.cellParamName}</strong>
                    </EllipsisTableCell>
                  </Tooltip>
                );
              })}

            {scheduleCellParamColumns &&
              scheduleCellParamColumns.map(n => {
                return (
                  <Tooltip title={n.cellParamDisplayName} key={n.cellParamId}>
                    <EllipsisTableCell>
                      <strong>{n.cellParamDisplayName}</strong>
                    </EllipsisTableCell>
                  </Tooltip>
                );
              })}
          </TableRow>
        </TableHead>

        {scheduleCellParamValues && (
          <TableBody>
            {scheduleCellParamValues.map((document, index) => {
              return (
                <OfferPaymentPlanParamsRowComponent
                  scheduleCellParamColumns={scheduleCellParamColumns}
                  key={index}
                  rowIdx={index}
                  rowData={document}
                  handleRowPropertyChange={handleRowPropertyChange}
                  handlePropertyParamChange={handlePropertyParamChange}
                  isEditable={isEditable}
                  fixedTableColumns={fixedTableColumns}
                  getDynamicInputParams={getDynamicInputParams}
                />
              );
            })}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}

OfferPaymentPlanParamsListView.propTypes = {
  fixedTableColumns: PropTypes.array.isRequired,
  scheduleCellParamColumns: PropTypes.array,
  scheduleCellParamValues: PropTypes.array,
  handleRowPropertyChange: PropTypes.func.isRequired,
  handlePropertyParamChange: PropTypes.func.isRequired,
  getDynamicInputParams: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired
};

export default OfferPaymentPlanParamsListView;
